import { render, staticRenderFns } from "./UserPersonalCardUpdate.vue?vue&type=template&id=49c8eec9&"
import script from "./UserPersonalCardUpdate.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports